// « Ma ville » : rayon par defaut des sorties proposees autour de la ville du
// membre (decision du 2026-10-28). Meme valeur que le serveur
// (functions/src/domain/approximateZone.js, DEFAULT_SEARCH_RADIUS_KM).
export const DEFAULT_SEARCH_RADIUS_KM = 100;
